import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
//i18n
import { withTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import lightMednetLogo from "assets/images/logos/mednet_logo_customer_portal.png"

const Sidebar = () => {
  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div className="navbar-brand-box text-start">
          {/* Skote Logo Dark */}
          <Link to="/" className="logo logo-dark">
            <span className="logo-sm">
              <img src={lightMednetLogo} alt="mednet logo" height="25" />
            </span>
            <span className="logo-lg">
              <img src={lightMednetLogo} alt="mednet logo" height="60" />
            </span>
          </Link>
        </div>
      </div>
    </React.Fragment>
  )
}

Sidebar.propTypes = {
  type: PropTypes.string,
}

const mapStatetoProps = (state) => {
  return {
    layout: state.Layout,
  }
}
export default connect(mapStatetoProps, {})(withTranslation()(Sidebar))
